(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"]) return;
  try {
    

jQuery(document).ready(function ($) {

  $('.btn-close').on('click', function () {
    $(this).parents('.parent-close').slideUp();
  });

});


/* BLACK FRIDAY COUNTDOWN */

(function () {

  function initBlackFridayCountdown() {

    var countdowns = document.querySelectorAll('.black-friday-countdown');

    countdowns.forEach(function (timer) {

      if (timer.dataset.initialized === 'true') return;

      timer.dataset.initialized = 'true';

      var targetDate = new Date(timer.dataset.countdown).getTime();
      var expiredText = timer.dataset.expiredText || 'SALE IS LIVE!';

      if (isNaN(targetDate)) {
        timer.innerHTML = 'Invalid countdown date';
        return;
      }

      function updateCountdown() {

        var now = new Date().getTime();
        var distance = targetDate - now;

        if (distance <= 0) {
          timer.innerHTML = expiredText;
          return;
        }

        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance / (1000 * 60 * 60)) % 24);
        var minutes = Math.floor((distance / (1000 * 60)) % 60);
        var seconds = Math.floor((distance / 1000) % 60);

        var daysEl = timer.querySelector('.bf-days');
        var hoursEl = timer.querySelector('.bf-hours');
        var minutesEl = timer.querySelector('.bf-minutes');
        var secondsEl = timer.querySelector('.bf-seconds');

        if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
        if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
        if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
        if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');

      }

      updateCountdown();

      var interval = setInterval(function () {

        updateCountdown();

        if (targetDate <= new Date().getTime()) {
          clearInterval(interval);
        }

      }, 1000);

    });

  }

  initBlackFridayCountdown();

})();


  } catch(e) { console.error(e); }
})();
})();
